import MideaIcon from './index.vue';

export default MideaIcon;


// WEBPACK FOOTER //
// ./src/components/Icon/index.js